export interface DeleteAutorizacionMedica {
  ignorandoAutorizacionMedica: boolean;
}

export interface DacInfoStore extends DeleteAutorizacionMedica {}

export const dacInfoStore: (state) => DacInfoStore = state => {
  const { expedientes } = state;

  return {
    ignorandoAutorizacionMedica: expedientes.ignorandoAutorizacionMedica
  };
};
